(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    const forms = document.querySelectorAll(
      '.ml-subscribe-form-36846630 form, #bfwt-newsletter-page-form, .bfwt-newsletter-inline-form'
    );
    if (forms.length === 0) {
      return;
    }

    const showMessage = (msg, type = 'error') => {
      if (window.BFWT_Accessibility) {
        window.BFWT_Accessibility.announce(
          (type === 'error' ? 'Error: ' : 'Success: ') + msg,
          'assertive'
        );
      }
      window.BFWT_Toast?.[type === 'error' ? 'error' : 'success'](msg);
    };

    forms.forEach((form) => {
      form.addEventListener(
        'submit',
        async function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();

          const submitBtn =
            form.querySelector('button[type="submit"]') ||
            form.querySelector('button');
          if (!submitBtn) {
            return;
          }

          // 1. Email permission checkbox (GDPR)
          const gdprCheckboxes = form.querySelectorAll('input[name="gdpr[]"]');
          let emailChecked = false;
          let emailCheckboxExists = false;
          gdprCheckboxes.forEach((cb) => {
            if (cb.value === 'Email') {
              emailCheckboxExists = true;
              if (cb.checked) {
                emailChecked = true;
              }
            }
          });
          if (emailCheckboxExists && !emailChecked) {
            showMessage('Please accept the Email permission to subscribe.');
            return;
          }

          // 2. Email Presence & Format Validation
          const emailInputEl = form.querySelector('input[type="email"]');
          const emailVal = emailInputEl ? emailInputEl.value.trim() : '';
          if (!emailVal) {
            showMessage('Please enter your email address.');
            return;
          }
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(emailVal)) {
            showMessage('Please enter a valid email address.');
            return;
          }

          // 3. Cloudflare Turnstile verification
          try {
            await window.bfwtTurnstile.ensureToken(form);
          } catch (err) {
            window.bfwtTurnstile.reset(form);
            showMessage('Security check failed. Please try again.');
            return;
          }

          // UI Loading State
          submitBtn.disabled = true;
          submitBtn.classList.add('is-loading');

          const emailInput = form.querySelector('input[type="email"]');
          const turnstileInput = form.querySelector(
            '[name="cf-turnstile-response"]'
          );

          const payload = {
            email: emailInput ? emailInput.value.trim() : '',
            'cf-turnstile-response': turnstileInput ? turnstileInput.value : '',
          };

          const apiUrl =
            window.bfwtVars?.newsletterApiUrl ||
            '/wp-json/app-api/v1/subscribe';

          try {
            const response = await fetch(apiUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': window.bfwtVars?.nonce || '',
              },
              body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (response.ok && data.success) {
              // Track Google Analytics conversion event
              if (typeof window.bfwt_trackEvent === 'function') {
                window.bfwt_trackEvent('newsletter_signup', {
                  source:
                    form.id === 'bfwt-newsletter-page-form'
                      ? 'website_page'
                      : 'website_sheet',
                  page_path: window.location.pathname,
                  event_category: 'conversion',
                });
              }

              showMessage(
                data.data?.message ||
                  'Thanks! We have sent a verification link to your email. Please check your inbox.',
                'success'
              );
              form.reset();

              // Close the floating sheet drawer (only if it's the sheet form)
              if (form.closest('.bfwt-floating-sheet')) {
                if (
                  window.sheetManager &&
                  typeof window.sheetManager.closeAllSheets === 'function'
                ) {
                  window.sheetManager.closeAllSheets();
                } else {
                  const closeBtn = document.querySelector(
                    '#sheet-newsletter [data-sheet-close]'
                  );
                  if (closeBtn) {
                    closeBtn.click();
                  }
                }
              }
            } else {
              throw new Error(
                data.data?.message || data.message || 'Subscription failed.'
              );
            }
          } catch (err) {
            showMessage(err.message);
            window.bfwtTurnstile?.reset(form);
          } finally {
            submitBtn.disabled = false;
            submitBtn.classList.remove('is-loading');
          }
        },
        true
      );
    });
  });
})();
